import { FaCheck, FaTimes } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { usePaymentCompleteMutation } from "../store/api/admin/paymentSlice";
import { useEffect, useState } from "react";
import { updateLogInUser } from "../store/reducer/UserReducer";
import { useDispatch, useSelector } from "react-redux";
import { useRetryPaymentMutation } from "../store/api/school/PaymentHistorySlice";

const PaymentComplete = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);

  const resultCode = queryParams.get("resultCode");
  const cardType = queryParams.get("cardType");
  const transactionId = queryParams.get("transactionId");
  const referenceId = queryParams.get("referenceId");
  const amount = queryParams.get("amount");
  const orderNumber = queryParams.get("orderNumber");
  const paymentMethodId = queryParams.get("paymentMethodId");
  const completeToken = queryParams.get("ct");

  const { user } = useSelector((state) => state.UserReducer);
  const role = user?.role === "super_admin" ? "admin" : user?.role;

  const [retryLoading, setRetryLoading] = useState(false);

  // subscription
  const [paymentComplete] = usePaymentCompleteMutation();

  const [retryPayment] = useRetryPaymentMutation();

  const handleSubmit = async () => {
    toast.dismiss();

    const payload = {
      referenceId,
      paymentMethodId,
      resultCode: Number(resultCode),
      paymentStatus: "Completed",
      transactionId,
      completeToken,
    };

    try {
      let response = await paymentComplete(payload).unwrap();

      if (response.statusCode === 200) {
        toast.success(response.message);
        dispatch(
          updateLogInUser({
            plan_id: response.data.plan_id,
            is_payment_active: 1,
            payment_status: "Completed",
            is_free_used: 0,
          }),
        );
      }
    } catch (err) {
      const message =
        err?.data?.message || err.message || "Something went wrong!";
      toast.error(message);
    }
  };

  const handleRetry = async () => {
    toast.dismiss();
    setRetryLoading(true);
    try {
      const response = await retryPayment(orderNumber).unwrap();
      if (response.statusCode === 200 || response.statusCode === 201) {
        window.open(response.data.iframe_url, "_blank");
      }
    } catch (err) {
      toast.error(err?.data?.message || "Failed to retry payment");
    } finally {
      setRetryLoading(false);
    }
  };

  useEffect(() => {
    if (resultCode === "0") {
      handleSubmit();
    }
  }, [resultCode]);

  return (
    <div className="payment-complete">
      <div className="p-0">
        {resultCode === "0" ? (
          <div className="payment-success">
            <div className="success-card">
              <div className="success-icon">
                <FaCheck />
              </div>
              <h2>Payment Successful!</h2>
              <p>
                Thank you for your payment. Your transaction has been completed.
              </p>

              <div className="order-details">
                <div className="detail-row">
                  <span>Order ID:</span>
                  <span>{orderNumber}</span>
                </div>
                <div className="detail-row">
                  <span>Amount Paid:</span>
                  <span>${amount / 100}</span>
                </div>
                <div className="detail-row">
                  <span>Payment Method:</span>
                  <span>{cardType}</span>
                </div>
              </div>

              <div>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => navigate(`/dashboard`)}
                >
                  Dashboard
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className="payment-success">
            <div className="success-card">
              <div className="success-icon failed-icon">
                <FaTimes />
              </div>
              <h2>Payment Failed</h2>
              <p>
                Unfortunately, your payment could not be processed. Please check
                your card details or try again later.
              </p>

              <div className="order-details">
                <div className="detail-row">
                  <span>Order ID:</span>
                  <span>{orderNumber}</span>
                </div>
              </div>

              <div>
                {role === "parent" ? (
                  <button
                    type="button"
                    className="btn btn-primary btn-failed"
                    onClick={handleRetry}
                    disabled={retryLoading}
                  >
                    {retryLoading ? (
                      <div
                        className="spinner-border spinner-border-sm"
                        role="status"
                      >
                        <span className="sr-only p-0"></span>
                      </div>
                    ) : (
                      "Try Again"
                    )}
                  </button>
                ) : (
                  <button
                    type="button"
                    className="btn btn-primary btn-failed"
                    onClick={() => navigate(`/pricing-plan`)}
                  >
                    Try Again
                  </button>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentComplete;
